"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/EnrolItem.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Schedules_template = require("./Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    Row_template = require("../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "list-group-item only-dark-bg-fade border-bottom"
      },
    marko_attrs1 = {
        "class": "d-block text-center"
      },
    marko_attrs2 = {
        "class": "font-medium-3"
      },
    marko_attrs3 = {
        "class": "text-ellipsis-2 text-muted"
      },
    marko_attrs4 = {
        "class": "font-medium-3"
      },
    marko_attrs5 = {
        "class": "text-ellipsis-2 text-muted"
      },
    marko_attrs6 = {
        "class": "badge badge-success"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const { type, id, captions } = input.for

  const { status, percentage } = input.progress.current

  const isCompleted = percentage == 100

  out.be("li", marko_attrs0, "0", component);

  Row_tag({
      class: "d-flex align-items-center",
      col: [
          {
              ns: "col-md-1 col-2",
              qs: "col-md-1 col-2",
              hs: "col-md-1 col-7",
              renderBody: function(out) {
                if (input.readonly) {
                  out.be("span", marko_attrs1, "3", component);

                  Image_tag({
                      alt: "Poster",
                      src: captions.poster,
                      class: "rounded-circle",
                      style: "width:50px;height:50px"
                    }, out, __component, "4");

                  out.ee();
                } else {
                  route_link_tag({
                      href: (("/classroom/" + type) + "/") + id,
                      class: "d-block text-center",
                      renderBody: function(out) {
                        Image_tag({
                            alt: "Poster",
                            src: captions.poster,
                            class: "rounded-circle",
                            style: "width:50px;height:50px"
                          }, out, __component, "6");
                      }
                    }, out, __component, "5");
                }
              }
            },
          {
              renderBody: function(out) {
                Row_tag({
                    class: "no-gutters d-flex align-items-center",
                    col: [
                        {
                            ns: "col-md-5 col-12",
                            qs: "col",
                            hs: "col-7",
                            renderBody: function(out) {
                              if (input.readonly) {
                                out.e("span", null, "10", component, 2)
                                  .e("span", marko_attrs2, "11", component, 1)
                                    .t(captions.name, component)
                                  .e("div", marko_attrs3, "12", component, 1)
                                    .t(captions.description, component);
                              } else {
                                route_link_tag({
                                    href: (("/classroom/" + type) + "/") + id,
                                    renderBody: function(out) {
                                      out.e("span", marko_attrs4, "14", component, 1)
                                        .t(captions.name, component);

                                      out.e("div", marko_attrs5, "15", component, 1)
                                        .t(captions.description, component);
                                    }
                                  }, out, __component, "13");
                              }
                            }
                          },
                        {
                            ns: "col-md-4 col-12",
                            qs: "col-4",
                            hs: "col-5",
                            renderBody: function(out) {
                              if (input.dates && ((status == "new") || isCompleted)) {
                                Schedules_tag({
                                    list: input.dates,
                                    clickable: true
                                  }, out, __component, "17");
                              }
                            }
                          },
                        {
                            class: "col-md-1 d-sm-block d-none",
                            renderBody: function(out) {
                              if (isCompleted && input.rewards.certificates.length) {
                                if (input.readonly) {
                                  out.be("span", null, "19", component);

                                  Image_tag({
                                      alt: "Poster",
                                      src: "/images/medals/088-medal-11.png",
                                      style: "width:50px;height:50px"
                                    }, out, __component, "20");

                                  out.ee();
                                } else {
                                  route_link_tag({
                                      href: "/achievement/" + id,
                                      renderBody: function(out) {
                                        Image_tag({
                                            alt: "Poster",
                                            src: "/images/medals/088-medal-11.png",
                                            style: "width:50px;height:50px"
                                          }, out, __component, "22");
                                      }
                                    }, out, __component, "21");
                                }
                              }
                            }
                          },
                        {
                            class: "col-md-2 col-12 text-right",
                            renderBody: function(out) {
                              if (status == "new") {
                                out.be("span", marko_attrs6, "24", component);

                                Locale_tag({
                                    text: "New"
                                  }, out, __component, "25");

                                out.ee();
                              } else {
                                out.be("span", {
                                    "class": marko_classValue("ml-2 " + (isCompleted ? "text-success" : false))
                                  }, "26", component, null, 1);

                                out.t(percentage ? !isCompleted ? percentage.toFixed(1) + "%" : "" : "0%", component);

                                Locale_tag({
                                    text: "Completed"
                                  }, out, __component, "27");

                                out.ee();
                              }
                            }
                          }
                      ]
                  }, out, __component, "8");
              }
            }
        ]
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
